import { render, staticRenderFns } from "./EditQuestionModal.vue?vue&type=template&id=9b6f869c&"
import script from "./EditQuestionModal.vue?vue&type=script&lang=js&"
export * from "./EditQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports